import DataTable from '../components/DataTable'
import { KTSVG } from '../../_metronic/helpers'
import 'react-loading-skeleton/dist/skeleton.css'
import { Link } from 'react-router-dom'
import Swal from 'sweetalert2'
import { postRequestOptions } from '../helpers/Fetchwrapper'
import GetPagePermission from '../components/GetPagePermission'

function ProductConversionList() {
	const hasPermission = GetPagePermission('/product-conversions')
	const canDelete = GetPagePermission('/delete-product-conversions')

	const handleDelete = async (row: any) => {
		const confirm = await Swal.fire({
			title: 'Are you sure?',
			text: `This will permanently delete product conversion ${row.conversionNo}: its finished goods stock movements, packing item movements and accounting voucher.`,
			icon: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#ec008c',
			cancelButtonText: 'Cancel',
			confirmButtonText: 'Yes, Delete',
		})
		if (!confirm.isConfirmed) {
			return
		}

		try {
			const response = await fetch(`${process.env.REACT_APP_API_URL}product-conversions/delete/${row.id}`, postRequestOptions({}))
			const data = await response.json()
			if (data.success) {
				Swal.fire({ icon: 'success', title: 'Success', text: data.successMessage }).then(() => window.location.reload())
			} else {
				Swal.fire({ icon: 'error', title: 'Error', text: data.errorMessage || data.errors || 'Action failed.' })
			}
		} catch (error) {
			Swal.fire({ icon: 'error', title: 'Error', text: 'An error occurred.' })
		}
	}

	const columns = [
		{ value: 'id', title: 'Id', style: { textAlign: 'center' } },
		{ value: 'conversionNo', title: 'Conversion No', style: { textAlign: 'left' } },
		{ value: 'conversionDate', title: 'Date', style: { textAlign: 'left' } },
		{ value: 'projectName', title: 'Project', style: { textAlign: 'left' } },
		{ value: 'productName', title: 'Product', style: { textAlign: 'left' } },
		{ value: 'sourcePacking', title: 'From Pack Size', style: { textAlign: 'left' } },
		{ value: 'sourceQuantity', title: 'Qty', style: { textAlign: 'right' } },
		{ value: 'targets', title: 'To Pack Sizes', style: { textAlign: 'left' } },
		{ value: 'warehouseName', title: 'Warehouse', style: { textAlign: 'left' } },
		{ value: 'createdBy', title: 'Created By', style: { textAlign: 'left' } },
		{
			value: 'action',
			title: 'Action',
			style: { textAlign: 'left', whiteSpace: 'nowrap' },
			hasActionsComponent: true,
			actionsComponent: ((row: any) => {
				return (
					<>
						<Link className="btn btn-light-primary btn-sm me-1" to={`/product-conversion-details/${row.id}`}>
							<KTSVG
								path="/media/svg/icons/Layout/Layout-grid.svg"
								className="svg-icon-5 svg-icon"
							/>		Details
						</Link>
						{canDelete === 1 &&
							<button type="button" className="btn btn-light-danger btn-sm me-1" onClick={() => handleDelete(row)}>
								Delete
							</button>
						}
					</>
				)
			}),
		},
	]

	const filters = {
		id: { filterType: 'like', filterValue: '' },
		conversionNo: { filterType: 'like', filterValue: '' },
		conversionDate: { filterType: 'like', filterValue: '' },
		projectName: { filterType: 'like', filterValue: '' },
		productName: { filterType: 'like', filterValue: '' },
		sourcePacking: { filterType: 'like', filterValue: '' },
		sourceQuantity: { filterType: 'like', filterValue: '' },
		targets: { filterType: 'like', filterValue: '' },
		warehouseName: { filterType: 'like', filterValue: '' },
		createdBy: { filterType: 'like', filterValue: '' },
	}

	const url = process.env.REACT_APP_API_URL + 'product-conversions/dt'

	return (
		<>
			{hasPermission === 1 &&
				<div className="card card-custom">
					<div className="card-header">
						<div className="card-title">
							<KTSVG path="/media/svg/icons/Text/Bullet-list.svg" className="svg-icon-1 svg-icon-primary" />
							<span className="text fw-bolder" style={{ marginLeft: '10px' }}>
								Product Conversions
							</span>
						</div>
						<div className="card-toolbar">
							<Link to="/product-conversion-create" className="btn btn-sm btn-primary">
								<KTSVG path="/media/svg/icons/Navigation/Plus.svg" className="svg-icon-5 svg-icon" /> New Conversion
							</Link>
						</div>
					</div>

					<div className="card-body">
						<DataTable url={url} columns={columns} filters={filters} />
					</div>
				</div>
			}
		</>
	)
}

export default ProductConversionList
